
import { Vue, Prop } from 'vue-property-decorator';
export default class PreviewMode extends Vue {
  @Prop({ default: '' }) readonly text: string | undefined;
}
